'use strict';

import $ from 'jquery';
// import mpro from './mpro.init';

/**
 * @param {JQuery<HTMLElement>} containers
 */
export const initFileUploadDecorator = containers => {
	for (const container of containers) {
		decorateFileUploadInput(container, $(container).data('file-upload') || {});
	}
};

/**
 * @param {string} template
 * @param {{ [key: string]: string; }} vars
 */
// export const replaceTemplateVars = (template, vars) => {
// 	for (const [key, value] of Object.entries(vars)) {
// 		template = template.replace(new RegExp(`\\[\\[\\s*${key}\\s*\\]\\]`, 'g'), value);
// 	}
// 	return template;
// };

/**
 * @param {number} bytes
 */
// @ts-ignore: Not all code paths return a value.ts(7030)
// export const returnFileSize = (bytes) => {
// 	if (bytes < 1024) {
// 		return bytes + 'bytes';
// 	}
// 	else if (bytes > 1024 && bytes < 1048576) {
// 		return (bytes / 1024).toFixed(1) + 'KB';
// 	}
// 	else if (bytes > 1048576) {
// 		return (bytes / 1048576).toFixed(1) + 'MB';
// 	}
// };

/**
 *
 * @param {HTMLElement} uploadContainer
 * @param {*} options
 */
export const decorateFileUploadInput = async (uploadContainer, options = {}) => {

	const $uploadContainer = $(uploadContainer);
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $fileInput = $uploadContainer.find('input[type="file"]').first();
	let $uploadedFiles = $uploadContainer.find('input[data-file-id]');
	const data = $fileInput.data();
	const maxFileSize = mpro.humanReadableToBytes(data.maxFileSize);

	/**
	 * @param {JQuery} $delButton
	 */
	const deleteUploadedFile = $delButton => {

		const delId = $delButton.data('file-control-delete');
		const $delFileInput = $uploadedFiles.filter(`[data-file-id="${delId}"]`);

		const delName = $delFileInput.data('file-deleted-name');
		if (delName) {
			$delFileInput.prop('name', delName).removeAttr('data-form-file').removeData('form-file');
			$uploadedFiles = $uploadedFiles.not($delFileInput);
		}
		const $fileControl = $delButton.closest('[data-file-control]');
		if ($fileControl.length > 0) {
			$fileControl.fadeOut('fast', () => $fileControl.remove());
		}
	};

	$uploadContainer.find('[data-file-control-delete]').on('click', function(e) {
		e.preventDefault();
		deleteUploadedFile($(this));
	});

	// Make sure posted files get sent as deleted
	$fileInput.on('change', e => {
		$uploadedFiles.each(function() {
			// @ts-ignore
			deleteUploadedFile($uploadContainer.find('[data-file-control-delete="' + $(this).data('file-id') + '"]'));
		});

		if (maxFileSize > 0) {

			const files = $fileInput[0].files;

			// Added new files
			if (files.length > 0) {
				for (const file of files) {
					if (file.size > maxFileSize) {
						mpro.alert({
							title: mpro.langvar('error_file_too_large') + ` (${file.name})`,
							content: mpro.langvar('error_max_filesize', { filesize: data.maxFileSize }),
						});
						$fileInput.val(null);
					}
				}
			}
		}
	});
};

export default mpro;